import { useMutation } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';
import type { ICourtRole } from '../../Interfaces/ICourtRole';

export const useUpdateCourtRole = () => {
  const { mutateAsync: updateCourtRole, isPending: isPendingUpdateCourtRole } =
    useMutation({
      mutationFn: (courtRole: ICourtRole) =>
        customFetcher({
          endpoint: '/courtrole',
          method: 'PUT',
          body: courtRole,
        }),
    });
  return { updateCourtRole, isPendingUpdateCourtRole };
};
